module.exports = __webpack_public_path__ + "svg/image-puzzle.svg?1efbed893d0f75c9c032df446e8423c7";